import {
  collection,
  doc,
  query,
  orderBy,
  limit,
  onSnapshot,
  updateDoc,
  Unsubscribe,
  QuerySnapshot,
  DocumentData
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { AppNotification, AppNotificationModel, NotificationDocumentData } from '../models/AppNotification';

export class NotificationsService {
  // Mirrors iOS UserNotificationViewModel — notifications are visible to all
  // signed-in users; 'chat' notifications are filtered by targetUserId
  static listen(userId: string, onUpdate: (notifications: AppNotification[]) => void, onError: (e: Error) => void): Unsubscribe {
    const q = query(collection(db, 'notifications'), orderBy('timestamp', 'desc'), limit(100));

    return onSnapshot(
      q,
      (snapshot: QuerySnapshot<DocumentData>) => {
        const notifications = snapshot.docs
          .map(d => AppNotificationModel.fromFirestore(d.id, d.data() as NotificationDocumentData))
          // Chat notifications are targeted — only show ones meant for this user
          .filter(n => n.targetUserId == null || n.targetUserId === userId);
        onUpdate(notifications);
      },
      onError
    );
  }

  static async markAsRead(notificationId: string, userId: string): Promise<void> {
    await updateDoc(doc(db, 'notifications', notificationId), {
      [`readBy.${userId}`]: true
    });
  }
}
